import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('page-header', ['policy-status-icon', 'policy-status-description']);

interface PageHeaderController extends angular.IStrictController {
    header: string;
    subheader: string;
    policyInfo?: CustomerPolicyInfo;
    bottomBorder: string;
    hidePolicyStatus?: string;
    showPolicyStatus: () => boolean;
}

module.component('pageHeader', {
    template: template,
    bindings: {
        header: '@',
        subheader: '@',
        policyInfo: '<?',
        bottomBorder: '@',
        hidePolicyStatus: '@?'
    },
    controller: function(this: PageHeaderController) {
        this.$onInit = () => {
            this.showPolicyStatus = () => {
                return !!this.policyInfo && this.hidePolicyStatus !== 'true';
            };
        };
    }
});

export { module };
